var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1EA7A8;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.4,324.2V557h-42.5L233.6,410.5h-1.7V557h-49.2V324.2h43.2l100.5,146.4h2V324.2H377.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.6,324.2V557h-49.2V324.2H455.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698.5,440.6c0,25.4-4.8,47-14.4,64.8c-9.6,17.8-22.6,31.4-39.1,40.7c-16.5,9.4-35,14-55.5,14 c-20.7,0-39.2-4.7-55.7-14.1c-16.4-9.4-29.4-23-39-40.8c-9.5-17.8-14.3-39.4-14.3-64.7c0-25.4,4.8-47,14.3-64.8 c9.5-17.8,22.5-31.4,39-40.7c16.4-9.4,35-14,55.7-14c20.5,0,39,4.7,55.5,14c16.5,9.4,29.5,22.9,39.1,40.7 C693.7,393.6,698.5,415.2,698.5,440.6z M648.6,440.6c0-16.4-2.4-30.3-7.3-41.6c-4.9-11.3-11.8-19.8-20.6-25.7 c-8.9-5.8-19.2-8.8-31.1-8.8c-11.9,0-22.3,2.9-31.1,8.8c-8.9,5.8-15.7,14.4-20.6,25.7c-4.9,11.3-7.3,25.2-7.3,41.6 c0,16.4,2.4,30.3,7.3,41.6c4.9,11.3,11.8,19.8,20.6,25.7c8.9,5.8,19.2,8.7,31.1,8.7c11.9,0,22.3-2.9,31.1-8.7 c8.9-5.8,15.7-14.4,20.6-25.7C646.2,470.9,648.6,457,648.6,440.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNioIcon);
export default __webpack_public_path__ + "static/media/nio_icon.4de0840f5b20c71172ee349f204fce43.svg";
export { ForwardRef as ReactComponent };